import { render, staticRenderFns } from "./mobile-menu.vue?vue&type=template&id=5f2bf7fe"
import script from "./mobile-menu.vue?vue&type=script&lang=ts"
export * from "./mobile-menu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports